























import { Component, Vue, Prop } from "vue-property-decorator";
import { Action } from "vuex-class";
// components
import AccessControlTable from "@/components/security/AccessControlTable.vue";
// types
import {
    ResourceEntity,
    SaveAclRequest,
    Resource,
    Claim
} from "@/services/security/types";
// service methods
import { saveACL, getACL } from "@/services/security/accessControlService";
import HeaderActionButtons from "@/components/layouts/HeaderActionButtons.vue";
const namespace: string = "authentication";

@Component({
    components: {
        AccessControlTable: AccessControlTable,
        HeaderActionButtons
    }
})
export default class AccessControl extends Vue {
    @Prop() private id!: string;
    @Prop() private name!: string;
    @Prop() private mode!: string;

    @Action("updateUserResourceClaims", { namespace }) updateUserResourceClaims: any;

    // local state
    resource = [] as Array<Resource>;

    loaded: boolean = false;

    // lifecycle hooks
    public created() {
        this.fetchData();
    }

    // methods
    fetchData() {
        getACL(this.id).then((response: Array<Resource>) => {
            this.resource = response;
            this.loaded = true;
        });
    }

    back() {
        this.goBack();
    }

    goBack() {
        if (this.mode === "User") {
            this.$router.push({
                name: "users"
            });
        } else if (this.mode === "UserGroup") {
            this.$router.push({
                name: "UserGroups"
            });
        }
    }

    save(evt: Event) {
        evt.preventDefault();
        const saveAclRequest: SaveAclRequest = {
            id: this.id,
            resources: this.filterClaims(this.resource)
        };
        saveACL(saveAclRequest).then(data => {
            this.updateUserResourceClaims(data);
            this.goBack();
        });
    }

    filterClaims(resource: Array<Resource>): Array<Resource> {
        resource.forEach(function (resource) {
            resource.resourceEntities.forEach(function (resEntity) {
                resEntity.claims = resEntity.claims.filter(
                    x => x.value === true
                );
            });
        });
        return resource;
    }

    updateResourceEntity(data: ResourceEntity, resourceType: string) {
        const root = this;
        this.resource.forEach(function (elem) {
            if (elem.name === resourceType) {
                elem.resourceEntities.forEach(function (record) {
                    if (record.id === data.id) {
                        record.claims = root.prepareClaimsArray(
                            data.jsonClaims
                        );
                    }
                });
            }
        });
    }

    prepareClaimsArray(jsonClaims: { [key: string]: boolean }): Array<Claim> {
        let claims: Array<Claim> = [];
        claims = Object.keys(jsonClaims).map(key => ({
            name: key,
            value: jsonClaims[key]
        }));
        return claims;
    }

    getResourceByType(type: string) {
        const result = this.resource.find(function (elem) {
            return elem.name === type;
        });
        return result;
    }
}
